import { render, staticRenderFns } from "./SQuesThirtyFive.vue?vue&type=template&id=022e1b0d&"
import script from "./SQuesThirtyFive.vue?vue&type=script&lang=js&"
export * from "./SQuesThirtyFive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports